<template>
    <Splide
        ref="splide"
        @splide:drag="onDrag"
        @splide:move="onMove"
        @splide:click="onClick"
        id="product-categories"
        class="relative cursor-grab active:cursor-grabbing"
        :options="options"
    >
        <SplideSlide v-for="category in productCategories" :key="category.id">
            <div class="mx-auto flex flex-col text-center w-16 md:w-20">
                <button
                    :class="[
                        productCategory && productCategory.id === category.id
                            ? 'bg-nutreance-green text-nutreance-green'
                            : 'bg-gray-400 text-gray-400',
                        'shrink-0 inline-flex items-center justify-center h-8 w-8 md:h-12 md:w-12 rounded-md mx-auto focus:outline-none',
                    ]"
                >
                    <svg-vue
                        class="h-5 w-5 md:h-8 md:w-8"
                        :icon="category.svg"
                        :key="category.svg"
                        aria-hidden="true"
                    />
                </button>

                <span
                    :class="[
                        productCategory && productCategory.id === category.id
                            ? 'text-nutreance-green font-bold'
                            : 'text-gray-600',
                        'text-xs mt-1',
                    ]"
                    >{{ category.name }}</span
                >
            </div>
        </SplideSlide>
    </Splide>
</template>

<script setup lang="ts">
import { inject, onMounted, ref } from "vue";
import type { AppEmitter } from "../../emitter";

const props = defineProps<{
    initialProductCategory?: any;
    productCategories?: any;
}>();

const emitter = inject<AppEmitter>("mitt")!;

const splide = ref<any>(null);
const productCategory = ref<any>(null);
const options = {
    type: "loop",
    start: 1,
    perPage: 7,
    focus: "center",
    pagination: false,
    breakpoints: {
        640: {
            perPage: 5,
        },
    },
};

onMounted(() => (productCategory.value = props.initialProductCategory));

function onClick(event: any, slide: any) {
    if (!slide.slide.className.includes("is-active")) {
        productCategory.value = null;
        splide.value.go(slide.index);
    }
}

function onDrag() {
    productCategory.value = null;
}

function onMove(event: any, key: any) {
    const nextCategory = props.productCategories[key];

    if (!nextCategory) {
        return;
    }

    productCategory.value = nextCategory;
    emitter.emit("productCategoryUpdated", nextCategory);
}
</script>

<style>
#product-categories > .splide__track:before,
#product-categories > .splide__track:after {
    content: "";
    position: absolute;
    z-index: 1;
    width: 6rem;
    top: 0;
    height: 100%;
    pointer-events: none;
}

#product-categories > .splide__track:before {
    left: 0;
    background: linear-gradient(
        to right,
        rgba(255, 255, 255, 1) 1.5rem,
        rgba(255, 255, 255, 0)
    );
}

#product-categories > .splide__track:after {
    right: 0;
    background: linear-gradient(
        to left,
        rgba(255, 255, 255, 1) 1.5rem,
        rgba(255, 255, 255, 0)
    );
}
</style>
